<div [ngClass]="{'background-active' : index === indexSelected &&( state.isDesktop || ctx.isTablet)}"
    class="download-pdf-card flex fd-col mapfre-fs-s dark ">
    <div class="title fw-500 mapfre-mt-xs ">{{data.descripcionProductoGenerico}}</div>
    <div class="desc">{{data.descripcionComercial}}
        <div *ngIf="(data.importe | number) > 0" class="primary price">desde {{data.importe | number}} €/mes</div>
    </div>
    <div class="buttons cp">
        <app-button [mt]="24" [fs]="15" (click)="utils.navToCallMeBack()" [perWidth]="82" [fw]="700" size="small"
            type="primary" text="Te llamamos"></app-button>
        <app-button [mt]="6" [fs]="15" [perWidth]="80" [fw]="500" size="small" type="link-primary" icon="icon-download"
            (click)="openDownloadMedicaGuideModal()" text="Descarga cuadro médico"></app-button>
    </div>
</div>
